import { render } from "./MigratePackageForm.vue?vue&type=template&id=5fb25faa"
import script from "./MigratePackageForm.vue?vue&type=script&lang=js"
export * from "./MigratePackageForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cargo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__